import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElement.vue?vue&type=template&id=36454fb8&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElement.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElement.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagenLeftElement.vue?vue&type=style&index=0&id=36454fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36454fb8",
  null
  
)

export default component.exports